import { render } from "./StudentCharacterization.vue?vue&type=template&id=7cfc8e0a"
import script from "./StudentCharacterization.vue?vue&type=script&lang=js"
export * from "./StudentCharacterization.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mda/www/akademia-taletow/spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__